function calculateDistance(lat1, lon1, lat2, lon2) {
    const toRadians = (deg) => deg * (Math.PI / 180);

    lat1 = toRadians(lat1);
    lat2 = toRadians(lat2);
    lon1 = toRadians(lon1);
    lon2 = toRadians(lon2);

    const sinLat1 = Math.sin(lat1);
    const sinLat2 = Math.sin(lat2);
    const cosLat1 = Math.cos(lat1);
    const cosLat2 = Math.cos(lat2);
    const cosLonDelta = Math.cos(lon1 - lon2);

    const centralAngle = Math.acos(sinLat1 * sinLat2 + cosLat1 * cosLat2 * cosLonDelta);
    const distanceInKm = centralAngle * 6371;

    return isNaN(distanceInKm) ? 0 : distanceInKm;
}

export const isUnderDistance = (property, dataCoordinates, p_maxDistance) => {
    if (!dataCoordinates) {
        return false;
    }

    const targetLatitude = dataCoordinates.latitude ?? 43.9493;
    const targetLongitude = dataCoordinates.longitude ?? 4.8055;
    const maxDistance = p_maxDistance ?? 0;

    const propertyLatitude = parseFloat(property.latitude);
    const propertyLongitude = parseFloat(property.longitude);

    const distance = calculateDistance(targetLatitude, targetLongitude, propertyLatitude, propertyLongitude);

    return maxDistance === 0 || distance <= maxDistance;
}